import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icons/common/closeBtn.svg'


const _withScopeId = n => (_pushScopeId("data-v-0aede682"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w100P",
  style: {"box-shadow":"0 0 13px rgba(0,0,0,0.2)","background-color":"rgb(255,255,255)"}
}
const _hoisted_2 = { class: "headerWrap h100P" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hamburgerMenu" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "close"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mainSubMenu subPageSubfontColor" }, "문서 뷰어", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mainSubMenu subPageSubfontColor" }, "문서 변환", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mainSubMenu subPageSubfontColor" }, "개인정보 필터", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mainSubMenu subPageSubfontColor" }, "고객지원", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.mYesMobile && _ctx.showSideMenu===true)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "popBg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSideMenu && _ctx.toggleSideMenu(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "h100P flexAlignCenter logo",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToUtils()))
        }, [
          _createElementVNode("img", {
            src: require(`@/assets/images/teamPl_logo.png`),
            alt: "teamPl logo"
          }, null, 8, _hoisted_3)
        ]),
        (_ctx.mYesMobile)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "menu_icon cursorP",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleSideMenu && _ctx.toggleSideMenu(...args)))
            }, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("nav", {
          class: _normalizeClass({ on: _ctx.showSideMenu })
        }, [
          (_ctx.mYesMobile)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "close_btn cursorP",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleSideMenu && _ctx.toggleSideMenu(...args)))
              }, _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("ul", {
            class: "mainMenu h100P",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSideMenu && _ctx.toggleSideMenu(...args)))
          }, [
            _createVNode(_component_router_link, { to: "/viewer" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/changer" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/filter" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/faq" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/developer" }, {
              default: _withCtx(() => [
                _createElementVNode("li", {
                  class: _normalizeClass(["mainSubMenu subPageSubfontColor", _ctx.mYesMobile? 'border2BottomBlue':'']),
                  style: {"line-height":"80px"}
                }, "개발자 페이지", 2)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/intro" }, {
              default: _withCtx(() => [
                _createElementVNode("li", {
                  class: _normalizeClass(["mainSubMenu subPageSubfontColor", _ctx.mYesMobile? 'border2BottomBlue':''])
                }, "회사소개", 2)
              ]),
              _: 1
            })
          ])
        ], 2)
      ])
    ])
  ], 64))
}